import React, { useCallback, useEffect, useState } from 'react';

import { App, Button, Input, Modal, Spin, Typography } from 'antd';

import { useListPostback, useUpdatePostback } from 'v2/hooks/campaigns';

import { Icon } from '@eduzz/ui-antd-theme';

interface IProps {
  open: boolean;
  product: any;
  onClose: any;
}

const PostbackModal: React.FC<IProps> = ({ open, product, onClose }) => {
  const { message } = App.useApp();
  const [postbackUrl, setPostbackUrl] = useState('');

  const { data: postbackData, isLoading: isLoadingPostback } = useListPostback(product.id, 'POSTBACK', 'URL');
  const updatePostbackMutation = useUpdatePostback();

  useEffect(() => {
    if (postbackData?.data?.length > 0) {
      setPostbackUrl(postbackData.data[0].script);
    }
  }, [postbackData?.data]);

  const handleSubmit = useCallback(async () => {
    try {
      await updatePostbackMutation.mutateAsync({
        productId: product.id,
        script: postbackUrl,
        destiny: 'POSTBACK',
        type: 'URL'
      });
      message.success('URL de postback atualizada!');

      if (onClose) {
        onClose();
      }
    } catch (error) {
      message.error('Ops, erro ao atualizar a URL de postback!');
    }
  }, [product.id, postbackUrl, onClose, updatePostbackMutation, message]);

  const isBusy = isLoadingPostback || updatePostbackMutation.isPending;

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title='URL de Postback'
      width={640}
      footer={
        <div className='flex flex-wrap items-center justify-end gap-2'>
          <Button type='text' disabled={isBusy} onClick={onClose}>
            Fechar
          </Button>
          <Button type='primary' danger disabled={isBusy} onClick={handleSubmit}>
            Salvar
          </Button>
        </div>
      }
    >
      <Typography.Paragraph className='!mb-4'>
        O recurso de postback permite que você receba notificações de alguns eventos que ocorrem dentro do sistema,
        possibilitando que além do produtor, o afiliado também tenha um melhor controle sobre seu negócio.{' '}
        <Typography.Link target='_blank' rel='noopener noreferrer' href='https://github.com/eduzz/postback' strong>
          Saiba mais
        </Typography.Link>
      </Typography.Paragraph>

      <Input
        size='small'
        value={postbackUrl}
        onChange={(e: any) => setPostbackUrl(e.target.value)}
        placeholder='Ex: http://www.meusite.com/postback'
        prefix={<Typography.Text type='secondary'>URL</Typography.Text>}
        suffix={
          isBusy ? (
            <Spin size='small' />
          ) : (
            <Button type='text' size='small' onClick={() => setPostbackUrl('')} icon={<Icon.X size={14} />} />
          )
        }
      />
    </Modal>
  );
};

export default PostbackModal;
